import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import Chat from './chat/Chat';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/gigs/Chat.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
    backgroundColor: '#fafafa',
  },

  paperFullScreenDialog: {
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: '50%',
      marginLeft: 'auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '40%',
      marginLeft: 'auto',
    },

    [theme.breakpoints.up('xl')]: {
      width: '30%',
    },
  },
}));

const FullScreenChatDialog = ({ gig }) => {
  const open = useModalOpen('Full Screen Chat');
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => dispatch(closeModal('Full Screen Chat'));

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullScreenDialog}
      direction="left"
      desktopDirection="left"
      styles={styles}
    >
      <Chat gig={gig} isDialog hasMilestones={false} />
    </TransitionDialog>
  );
};

export default FullScreenChatDialog;
